module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_11-40bd3b712d0cedb384c2885b936fb09c.png";